import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import type { Product } from '@/mocks/products';
import InquiryModal from '@/pages/home/components/InquiryModal';

interface RelatedProductsProps {
  products: Product[];
  currentId: string;
}

export default function RelatedProducts({ products, currentId }: RelatedProductsProps) {
  const navigate = useNavigate();
  const [modalProduct, setModalProduct] = useState<Product | null>(null);
  const related = products.filter(p => p.id !== currentId).slice(0, 4);

  if (related.length === 0) return null;

  return (
    <>
      <div className="mt-16 pt-12 border-t border-gray-100">
        <div className="mb-8">
          <p className="text-xs font-bold text-gray-400 uppercase tracking-[0.2em] mb-2">Related Products</p>
          <h3 className="text-2xl font-black text-gray-900 mb-0.5">同类商品</h3>
          <p className="text-sm text-gray-400">같은 카테고리 상품</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 gap-4">
          {related.map(product => (
            <div
              key={product.id}
              onClick={() => navigate(`/product/${product.id}`)}
              className="group bg-white border border-gray-200 rounded-xl overflow-hidden cursor-pointer hover:-translate-y-1 transition-all duration-300"
            >
              <div className="relative overflow-hidden bg-gray-50" style={{ paddingBottom: '70%' }}>
                <img
                  src={product.image}
                  alt={product.nameZh || product.name}
                  className="absolute inset-0 w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                {product.badge && (
                  <span className="absolute top-2 left-2 text-xs font-bold bg-black text-white px-2 py-0.5 rounded">
                    {product.badgeZh || product.badge}
                  </span>
                )}
              </div>
              <div className="p-3">
                <p className="text-sm font-bold text-gray-900 line-clamp-1 leading-snug mb-0.5">{product.nameZh || product.name}</p>
                <p className="text-xs text-gray-400 line-clamp-1 mb-2">{product.name}</p>
                {product.boxPrice > 0 ? (
                  <p className="text-sm font-black text-gray-900">{product.boxPrice} 元</p>
                ) : (
                  <p className="text-sm font-black" style={{ color: '#2E5240' }}>询价 / 문의</p>
                )}
                {product.boxQuantity > 0 && (
                  <p className="text-xs text-gray-400 mt-0.5">{product.boxQuantity}个/箱 <span className="text-gray-300">/ {product.boxQuantity}개입</span></p>
                )}
                <button
                  onClick={e => { e.stopPropagation(); setModalProduct(product); }}
                  className="mt-3 w-full py-2 text-xs font-bold border border-black text-black rounded-lg hover:bg-black hover:text-white transition-all whitespace-nowrap cursor-pointer"
                >
                  询价 / 문의하기
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>

      <InquiryModal product={modalProduct} onClose={() => setModalProduct(null)} />
    </>
  );
}
